import StopIcon from '@material-ui/icons/Stop';
import { CheckBox, DocumentFileIcon, MicrophoneIcon } from '@room-match/shared-ui-components';
import React, { useEffect, useState } from 'react';
import AudioProgressBar from 'shared/components/AudioProgressBar/AudioProgressBar';
import { useAudioProgressBar } from 'shared/hooks';
import IMedia from 'shared/interfaces/IMedia';
import { AudioInfo, AudioItemCont, AudioName, Duration } from './Item.styles';
interface Props {
  item: IMedia;
  checked?: boolean;
  handleSelect?: (m: IMedia) => void;
  file?: boolean;
}

const AudioItem: React.FC<Props> = ({ item: aud, checked, handleSelect, file }) => {
  const [audio] = useState(new Audio(aud.attributes.attachment_url));
  const {
    buffered,
    playing,
    setPlaying,
    duration,
    setDuration,
    handleBufferProgress,
    onTimeUpdate,
    setCurrrentProgress,
    stopBufferProgress,
    currrentProgress,
  } = useAudioProgressBar();

  useEffect(() => {
    const getAudioInfo = (e: any) => {
      setDuration(e.target.duration);
    };

    const onEnded = () => {
      setPlaying(false);
    };

    audio.addEventListener('loadedmetadata', getAudioInfo);
    audio.addEventListener('ended', onEnded);
    audio.addEventListener('timeupdate', (e: any) => onTimeUpdate(e));

    return () => {
      audio.pause();
      audio.removeEventListener('loadedmetadata', getAudioInfo);
      audio.removeEventListener('ended', onEnded);
      audio.removeEventListener('timeupdate', (e: any) => onTimeUpdate(e));
    };
  }, [audio, aud, handleBufferProgress, onTimeUpdate, setDuration, setPlaying]);

  const handleClick = () => {
    if (file) return window.open(`${aud.attributes.attachment_url}`, '_blank');

    if (playing) {
      audio.pause();
    } else {
      audio.play();
    }
    setPlaying(!playing);
  };

  return (
    <AudioItemCont>
      {file ? (
        <DocumentFileIcon className="documentIcon" style={{ height: 25, width: 25 }} />
      ) : playing ? (
        <div
          typeof="button"
          onClick={() => {
            audio.pause();
            audio.currentTime = 0;
            stopBufferProgress();
            setPlaying(false);
          }}
        >
          <StopIcon htmlColor="#3e8bff" />
        </div>
      ) : (
        <MicrophoneIcon />
      )}
      <AudioInfo
        onClick={() => {
          if (playing) return;
          handleClick();
        }}
      >
        <AudioName style={{ paddingRight: handleSelect ? 24 : 0 }}>{aud.attributes?.file_name}</AudioName>
        {!file && (
          <Duration>
            {playing ? (
              <AudioProgressBar
                duration={duration}
                currentProgress={currrentProgress}
                buffered={buffered}
                onChange={(e) => {
                  if (!audio) return;
                  audio.currentTime = e.currentTarget.valueAsNumber;
                  setCurrrentProgress(e.currentTarget.valueAsNumber);
                }}
              />
            ) : (
              <>
                {`${'Duration : '}`}
                {duration === 0
                  ? '--:--'
                  : duration < 3600
                    ? new Date(duration * 1000).toISOString().substring(14, 19)
                    : new Date(duration * 1000).toISOString().substr(11, 8)}
              </>
            )}
          </Duration>
        )}
      </AudioInfo>

      {handleSelect && (
        <div style={{ position: 'absolute', right: 0, zIndex: 10 }}>
          <CheckBox checked={checked} onClick={() => handleSelect(aud)} />
        </div>
      )}
    </AudioItemCont>
  );
};

export default AudioItem;
